<template>
  <div class="part3-carousel">
    <el-carousel height="310px" class="carousel" indicator-position="none">
      <el-carousel-item v-for="item in list" :key="item.id">
        <video class="image" v-if="item.path" controls nodownload>
          <source :src="item.path" type="video/mp4" />
        </video>
        <img class="image" :src="item.coverUrl" v-else @click="handleShowDetail(item)">
        <div class="title_bg">
          <p class="title">{{ item.title }}</p>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
// import { toDetailPage } from '@/views/CounselorContest/common.js'
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    handleShowDetail(item) {
      let routeUrl = this.$router.resolve({
        path: '/detail',
        query: { id: item.id }
      })
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.part3-carousel {
  width: 395px;
  height: 310px;
  background: linear-gradient(270deg,
      rgba(239, 246, 255, 0.55) 0%,
      #ecf4fe 100%);
  box-shadow: 0px 2px 4px 0px #d5e5f7;
  border-radius: 2px;

  .image {
    width: 100%;
    height: 260px;
    position: relative;
  }

  .title_bg {
    z-index: 2;
    font-family: MicrosoftYaHei;
    font-size: 18px;
    color: #000;
    font-style: normal;
    padding: 10px 10px 25px 10px;
    margin: 0;
    // background: linear-gradient(rgba(116,165,255,0.61) 0%, rgba(16,101,255,0.49) 100%), #BBDAFA;

    .title {
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }
}

@media screen and (max-width: 767px) {
  .part3-carousel {
    width: 100%;
    height: 230px;
    opacity: 1;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 1px rgba(213, 232, 227, 1);

    ::v-deep .el-carousel__container {
      height: 230px !important;
    }

    .image {
      width: 100%;
      height: 100%;
      position: relative;
    }

    .title_bg {
      bottom: 0;
      position: absolute;
      z-index: 2;
      font-family: MicrosoftYaHei;
      font-size: 18px;
      color: #ffffff;
      font-style: normal;
      padding: 10px 10px 25px 10px;
      margin: 0;
      background: linear-gradient(rgba(116, 165, 255, 0.61) 0%,
          rgba(16, 101, 255, 0.49) 100%),
        #bbdafa;

      .title {
        margin: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
  }
}

::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
  width: 8px;
  height: 8px;
  background: #d8d8d8;
  border-radius: 50%;
  opacity: 0.5;
}

::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 11px;
  height: 11px;
  background: #ffffff;
  border-radius: 50%;
  opacity: 1;
}

::v-deep .el-carousel__indicators--horizontal {
  display: flex;
  align-items: center;
  left: 56px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/part3/Part3Carousel.vue